export const UTM_SOURCE = 'utm_source';
export const UTM_MEDIUM = 'utm_medium';
export const UTM_CAMPAIGN = 'utm_campaign';
export const UTM_SOURCE_SFMC = 'sfmc';
export const UTM_MEDIUM_EMAIL = 'email';
export const UTM_TERM = 'utm_term';
export const UTM_CONTENT = 'utm_content';
